<template>
  <div id="share_page">

      <div class="dark_page">
        <div id="share_pop"  class="popup">
            <a class="close" @click="$emit('close')"></a>
            <h3>שיתוף עמוד המייסונג:</h3>

            <div class="soci">
                <a target="_blank" :href="'https://t.me/share/url?url=' + encodeURIComponent(item.link) +'&text=' + encodeURIComponent(item.name)"><i class="fa-brands fa-telegram"></i></a>
                <a target="_blank" :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(item.name + ' - ' + item.link)"><i class="fa-brands fa-whatsapp"></i></a>
               
                 <a target="_blank" :href="'https://www.facebook.com/share.php?u=' + encodeURIComponent(item.link)"><i class="fa-brands fa-facebook-f"></i></a>
            </div>

            <h4>לינק לשיתוף:</h4>
            <div @click="copy_link()"><i class="fas fa-copy"></i> <span v-text="item.link" style="white-space:nowrap; overflow:hidden; display:block; text-overflow: ellipsis;"></span></div>

        </div>
      </div>

  </div>
</template>

<script>


export default {
   // components: { VueClipboard },
  props: ["item"],
  methods: { 
    copy_link() {
        this.$copyText(this.item.link);
        alert('הלינק הועתק בהצלחה');
    },
    
  },
  computed: {

  },
  mounted () {
  },


}
</script>

<style scoped>
.dark_page { position: fixed; z-index:9999; top: 0px; left: 0px; right: 0px; bottom: 0px; background: rgba(0,0,0,0.80); display: flex; align-items: center; justify-content: center; height: 100%; }
#share_pop { border:2px solid #fff; width: 500px; padding: 40px; text-align: center; position: relative; max-width: 90%; }
#share_pop .soci { padding: 20px 0 40px 0; DISPLAY: FLEX;JUSTIFY-CONTENT: CENTER;}
#share_pop .soci a { display: inline-block;  width:63px; height: 63px; text-align: center; line-height: 55px; color: #fff; font-size: 22px; margin: 0 10px;}

.soci [class*="fa-whatsapp"] {
   background-color: #28E048;
    border-radius: 30px;
    color: #fff;
    display: inline-block;
    height: 60px;
    line-height: 60px;
    margin: auto 3px;
    width: 60px;
    font-size: 37px;
    text-align: center;
}
.soci [class*="fa-facebook-f"] {
   background-color: #1F4D9A;
    border-radius: 30px;
    color: #fff;
    display: inline-block;
    height: 60px;
    line-height: 60px;
    margin: auto 3px;
    width: 60px;
    font-size: 37px;
    text-align: center;
}
.soci [class*="fa-telegram"] {
        background-color: #FFF;
    border-radius: 60px;
    display: inline-block;
    height: 50px;
    line-height: 54px;
    margin: 0;
    width: 57px;
    font-size: 63px;
    text-align: center;
    COLOR: #2EA3D4;
    MARGIN-TOP: 4PX;
}
.dark_page[data-v-1908147f] {
   background: rgba(0,0,0,0.8) !IMPORTANT;
}
</style>